export const ACTION_SAVE_PAYMENT_ORDERS_PAGINATED = 'ACTION_SAVE_PAYMENT_ORDERS_PAGINATED';
export const ACTION_SAVE_PAYMENT_ORDER_DETAILS = 'ACTION_SAVE_PAYMENT_ORDER_DETAILS';
export const ACTION_CLEAN_PAYMENT_ORDER = 'ACTION_CLEAN_PAYMENT_ORDER';
export const ACTION_SAVE_PAYMENT_ORDER_TRANSACTIONS = 'ACTION_SAVE_PAYMENT_ORDER_TRANSACTIONS';
export const ACTION_SAVE_PAYMENT_ORDER_SAFE_BALANCE = 'ACTION_SAVE_PAYMENT_ORDER_SAFE_BALANCE';
export const ACTION_SAVE_PAYMENT_ORDER_WORK_FLOW = 'ACTION_SAVE_PAYMENT_ORDER_WORK_FLOW'
export const ACTION_SAVE_USER_PAYMENT_ORDERS_PAGINATED = 'ACTION_SAVE_USER_PAYMENT_ORDERS_PAGINATED';
export const ACTION_SAVE_CREDITCARD_PAYMENT_ORDER = 'ACTION_SAVE_CREDITCARD_PAYMENT_ORDER';
